<template>
  <div>

    <div class="page-listings">
        <section class="py-5 pixelsbg bs-shadow mobile-top">

        <div class="container">
          <div style="display: flex;">
          <h1 class="text-white mb0 lh1">Product School Report</h1>
        </div>

        <hr class="header-divide" />
        <div class="search-btns">
          <div class="left-side" style="margin-right: 20px">
            <div>
      
              <h5 className="text-white mb-[10px]">The Product School Report dataset contains historical information about Area Contractor Users and product school attendance history.</h5>

              <div class="radios">
              <div class="control-group">
                <label class="control control--radio">
                  Sales Reps
                  <input
                    type="radio"
                    name="radio"
                    checked="checked"
                    v-model="salesReps"
                    value="true"
                  />
                  <div class="control__indicator"></div>
                </label>
                <label class="control control--radio">
                  All Users
                  <input
                    type="radio"
                    name="radio"
                    v-model="salesReps"
                    value="false"
                  />
                  <div class="control__indicator"></div>
                </label>

              </div>
            </div>
    
              
              <div class="row">
                <div class="col-xs-12 col-12">


                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

      <section id="ScrollTarget" class="py-5 bs-shadow mobile-top">
        <div v-if="loading == true" class="container" style="margin-top:100px;">
        <div
                
                class="col-xs-12 col-sm-12 col-12 col-lg-12"
              >
                <div class="flex-box-wrap">
                  <div class="flex-internal">
                    <atom-spinner
                      :animation-duration="1000"
                      :size="40"
                      :color="'#575757'"
                    />
                    <p>Loading......</p>
                  </div>
                </div>
              </div>
            </div>
        
        <div v-else class="container">
          <SimplePagination
            :currPage="currPage"
            :totalPage="totalPage"
            :filteredPosts="filteredListings"
            :setPage="setPage"
          />
          
      
  
          <transition
            enter-active-class="animated fadeIn"
            leave-active-class="animated fadeOut"
            :duration="500"
            mode="out-in"
            appear
          >
          <div>
            <div class="step1" key="step1">
              <div class="listing">
            
                <div class="d-flex" style="margin-bottom: 20px">

               
              
                <a href="/product-school" style="display: flex;" class="mb0 lh1 mrauto list-btn dib d-flex center"><i class="material-icons">keyboard_arrow_left</i> Back</a>
                <download-csv
                  class="mb0 lh1 mlauto list-btn dib d-flex center"
                  :data="filteredListings"
                  :name="'product-scool-report' + '.csv'"
                  >Download CSV</download-csv
                >
                </div>
                <hr />
                <div class="row">

                  <div class="col col-12">
                   


                <table
                    
                      class="table-striped table-bordered"
                      style="display: table; width: 100%;"
                    >
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            class="table-link twenty"
                            @click="sortCol('Name')"
                            :class="
                              columnSort == 'Name'
                                ? 'column-active'
                                : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span class="mr-auto">Partner</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Name'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="table-link"
                            style="width: 8%;"
                            @click="sortCol('ACID')"
                            :class="
                              columnSort == 'ACID' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>ACID </span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'ACID'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            class="table-link twenty"
                            @click="sortCol('LastName')"
                            :class="
                              columnSort == 'LastName' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>User</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'LastName'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>

                          <th
                            scope="col"
                            class="table-link twenty"
                            @click="sortCol('email')"
                            :class="
                              columnSort == 'email'
                                ? 'column-active'
                                : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span class="mr-auto">Email</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'RepId'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>

                          <th
                            scope="col"
                            class="table-link"
                            style="width: 8%;"
                            @click="sortCol('RepId')"
                            :class="
                              columnSort == 'RepId'
                                ? 'column-active'
                                : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span class="mr-auto">Rep ID</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'RepId'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>

                          <th
                            scope="col"
                            class="table-link"
                            style="width: 10%;"
                            @click="sortCol('Attendance')"
                            :class="
                              columnSort == 'Attendance' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>Attendance</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'Attendance'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>


                          <th
                            scope="col"
                            class="table-link"
                            style="width: 10%;"
                            @click="sortCol('CreateDate')"
                            :class="
                              columnSort == 'CreateDate' ? 'column-active' : ''
                            "
                          >
                            <span style="display: flex; flex: 0 0 100%">
                              <span>Create Date</span>
                              <span class="ml-auto">
                                <i
                                  :class="
                                    columnSort == 'CreateDate'
                                      ? 'carrot-icon-active'
                                      : ''
                                  "
                                  class="material-icons carrot-icon"
                                >
                                  filter_list
                                </i>
                              </span>
                            </span>
                          </th>

                        







               
                        </tr>
                      </thead>

                      <tbody>
                     
                        <tr
                          scope="row"
                          v-bind:key="index"
                          v-for="(entry, index) in paginatedPosts"
                        >
                        <td>
                            {{ entry.Name }}
             
                  
                          </td>
                          <td>
                            {{ entry.ACID }}
                          </td>
                          <td>
                            {{ entry.FirstName + " " + entry.LastName }}
                          </td>
                          <td>{{ entry.Email }}</td>
                          <td>{{ entry.RepId }}</td>
                          <td>{{ entry.Attendance ? $moment(entry.Attendance).format("MM-DD-YYYY") : null}}</td>
                          <td
                        
                          >
                          {{$moment(entry.CreateDate).format("MM-DD-YYYY")}}</td>
                       

                         


             

                      
                        
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                
                     <div class="row">
                <div class="col col-12">
                  <div
                    class="
                      nav-btns
                      listing-header
                      d-flex
                      align-items-center
                      mt10
                      mb10
                      rounded
                      b-shadow
                    "
                  >
                  
  
  
  

                  </div>
                </div>
               
              </div>
              </div>
              <SimplePagination
                    class="mt20"
                    :currPage="currPage"
                    :totalPage="totalPage"
                    :filteredPosts="filteredListings"
                    :setPage="setPage"
                  />
            </div>
            </div>
          </transition>
        </div>
      </section>
    </div>
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import { AtomSpinner } from "epic-spinners";
  // import Avatar from "vue-avatar";
  // import Datepicker from "vuejs-datepicker";
  import VueDatePicker from '@vuepic/vue-datepicker';
  import Multiselect from "vue-multiselect";
  import { HollowDotsSpinner } from "epic-spinners";
  import Banner1 from "../components/Banners/banner1.vue";
  import vSelect from "vue-select";
  import JsonCSV from "vue-json-csv";
  import BackButton from '@/components/Buttons/BackButton.vue';
  import SimplePagination from "@/components/Pagination/SimplePagination.vue";
  import { jwtDecode } from "jwt-decode";
  import "vue-select/dist/vue-select.css";
  import "vue-multiselect/dist/vue-multiselect.min.css";
  // import "animate.css";
  
  const auth = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("SSCUSER"),
    },
  };
  
  export default {
    name: "ProductSchoolReport",
    components: {
      AtomSpinner,
      // Avatar,
      // Datepicker,
      VueDatePicker,
      Multiselect,
      HollowDotsSpinner,
      Banner1,
      vSelect,
      JsonCSV,
      BackButton,
      SimplePagination,
    },
    data() {
      return {
        ordermanageapi: import.meta.env.VITE_APP_ORDER_MANAGE_API,
        server: import.meta.env.VITE_APP_SERVER_URL,
        backend: import.meta.env.VITE_APP_SERVER_URL,
        registrants: null,
        firstName: null,
        lastName: null,
        namePreference: "",
        jobTitle: "",
        PhoneNumber: "",
        Email: "",
        Company: null,
        companyAddress: "",
        companyCity: "",
        companyState: "",
        companyZip: "",
        country: "United States", // Default value for country dropdown
        hasWorkedForCompetitors: false,
        competitorName: "",
        noHotelRequired: false, // Radio button value for hotel
        hasDietaryRestrictions: false, // Radio button value for dietary 
        dietaryRequirement: "",

        RepId: null,
        ACID: null,      
        loading: true,    
        countOfPage: 25,
        currPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
        check1: false,
        check2: false,
        check3: false,
        submitted: false,
        userDetails: null,
        showDetails: false,
        salesReps: true,
        colSort: false,
        columnSort: "",

             
      };
    },
    methods: {  
      firstLoad: function () {
    
        this.loading = true;
        this.$store.commit("setActivePage", "order-manage");
        //return axios.get(this.endPointCompute, auth).then((response) => {
        return axios
          .get(`${this.backend}/api/v1/product-school-report`, auth)
          .then((response) => {
            console.log(response);
            if (response.status === 401) {
              this.$router.push("/");
          } else {
            this.registrants = response.data;
            this.loading = false;
          }
          });
      },

      setPage: function (idx) {
          if (idx <= 0 || idx > this.totalPage) {
            return;
          }
          this.currPage = idx;
          const newQuery = {
              ...this.$route.query, 
              page: idx, 
          };
          this.$router.push({ query: newQuery });
      },

      formatDates(isoString) {
        if (!isoString) return '--'; // Handle null or undefined
        try {
          const date = new Date(isoString);
          if (isNaN(date.getTime())) return '--'; // Handle invalid dates
          return date.toLocaleString('en-US', {
            month: '2-digit',
            day: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true,
          });
        } catch {
          return '--'; // Fallback for any parsing errors
        }
      },

      showLightbox(entry){
        console.log(entry)
        this.showDetails = true;
        this.userDetails = entry
      },
      closeLightbox(){
        this.showDetails = false;
        this.userDetails = null;
      },

      sortCol: function (type) {
        console.log(type);
        this.columnSort = type;
        const COLUMN = type;

        if (this.colSort) {
          this.paginatedPosts.sort((a, b) => (a[COLUMN] > b[COLUMN] ? 1 : -1));
        } else {
          this.paginatedPosts.sort((a, b) => (a[COLUMN] < b[COLUMN] ? 1 : -1));
        }


        this.colSort = !this.colSort;
        this.columnSort = "";
    
    },
  
      formatDate(date) {
        var d = new Date(date),
          month = "" + (d.getMonth() + 1),
          day = "" + d.getDate(),
          year = d.getFullYear();
  
        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;
  
        return [year, month, day].join("-");
      },
  
      setPage(idx) {
        if (idx <= 0 || idx > this.totalPage) return;
        this.currPage = idx;
        this.$router.push({ query: { ...this.$route.query, page: idx } });
      },
    },
    computed: {

      filteredListings: function () {
        if (!this.registrants) {
          return []; // Return empty array if registrants is null
        }
        if (this.salesReps === true || this.salesReps === "true") {
          return this.registrants.filter(
            (registrant) => registrant.RepId !== 0 && registrant.RepId !== null
          );
        }
        return this.registrants;
      },
      paginatedPosts() {
        return this.filteredListings.slice(this.pageStart, this.pageStart + this.countOfPage);
      },

      totalPage: function () {
        return Math.ceil(this.registrants?.length / this.countOfPage);
      },

      pageStart: function () {
        return (this.currPage - 1) * this.countOfPage;
      },
      activeNav() {
        return this.$store.state.activePage;
      },
      colorGetter() {
        return this.$store.state.colors;
      },
      companyID() {
        let number = this.$store.state.user.ACId[0];
        this.acid = number;
      },
      states() {
        return new Set(this.acList.map((x) => x.State).sort());
      },
    },
    created() {
      this.$store.commit("showNavigation");
      // console.log(this.$route.path);
    },
    mounted() {
      this.firstLoad();
    },
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
  #pickDate1 input {
    border: 0 !important;
    outline: none !important;
  }
  
  .btn-primary:not(:disabled):not(.disabled).active,
  .btn-primary:not(:disabled):not(.disabled):active,
  .show > .btn-primary.dropdown-toggle {
    color: #fff;
    background-color: #00b4b4;
    border-color: #00b4b4;
  }
  
  .leadTime {
    background-color: #fff;
    line-height: 44px;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
  }
  .top-wrap {
    display: flex;
    align-items: flex-start;
  }
  .leadTime-bottom {
    align-items: flex-end;
  }
  .leadTime-header {
    background: #fff;
    color: #575757;
    display: flex !important;
  }
  .small-lh {
    line-height: 1.4em;
  }
  
  .listing {
    overflow: none;
  }
  
  .listing {
    background-color: #fff;
    line-height: 1;
    padding: 20px;
    margin-bottom: 5px;
    border-top: 0;
  }
  
  .table-responsive {
    display: table;
  }
  .table-striped tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.03) !important;
  }
  .table-bordered td,
  .table-bordered th {
    border: 1px solid #e8e8e8 !important;
  }
  .badge-success {
    color: #fff;
    background-color: #4d5967;
    background-color: #1eb5b6;
  }
  .table-striped a {
    color: #00b4b4;
  }
  .table-striped td,
  .table-striped th {
    padding: 5px;
    font-weight: 300 !important;
  }
  .listing {
    border-radius: 4px;
  }
  table td {
    line-height: 1;
  }
  .table-striped th {
    background: #00b4b4;
    background: #4d5967;
    color: #fff;
  }
  .table-striped {
    min-width: 100%;
    overflow: scroll;
  }
  .search-btns {
    display: flex;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .search-btns button {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: #4d5967;
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    cursor: pointer;
    max-height: 40px;
  }
  .search-btns .clear {
    margin-left: auto;
  }
  .search-btns .search {
    margin-left: 5px;
  }
  .search-btns button span {
    font-size: 20px;
    width: 20px;
    height: 20px;
    color: #fff;
  }
  .search-btns button:hover {
    background: #586575;
  }
  .search-btns button:active {
    background: #586575;
  }
  .search-btns button:disabled {
    opacity: 0.6;
    cursor: unset !important;
  }
  .search-btns button:disabled:hover {
    background: #4d5967;
  }
  .search-btns button:disabled:active {
    background: #4d5967;
  }
  
  @media all and (min-width: 768px) {
    .dates {
      display: flex;
      color: #757575 !important;
    }
  }
  .top-search {
    color: #757575;
  }
  select.form-control:not([size]):not([multiple]) {
    height: auto !important;
    padding: 10px !important;
    color: #757575;
  }
  .all-contractors {
    color: #757575 !important;
  }
  .header-divide {
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }
  .table-striped td:last-of-type {
    text-align: right;
  }
  .table-striped th:last-of-type {
    text-align: right;
  }
  .table-bordered td:first-of-type {
    border-right: none !important;
  }
  .table-bordered th:first-of-type {
    border-right: none !important;
  }
  .table-bordered td:last-of-type {
    border-left: none !important;
  }
  .table-bordered th:last-of-type {
    border-left: none !important;
  }
  .m50 {
    margin: 50px 0;
  }
  .nav-btns {
    display: flex;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.25s ease-out;
  }
  
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .slide-leave-active,
  .slide-enter-active {
    transition: 1s;
  }
  .slide-enter {
    transform: translate(100%, 0);
  }
  .slide-leave-to {
    transform: translate(-100%, 0);
  }
  .listing-header {
    background: #fff;
    color: #575757;
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
  }
  .loader {
    margin: 0 auto 20px;
    width: 100%;
    height: 25px;
    border-radius: 14px;
    border-bottom: 1px solid #fff;
    border-top: 1px solid #999;
    background: #ccc;
    overflow: hidden;
    position: relative;
  }
  
  .progress-bar {
    height: inherit;
    width: 0%;
    border-radius: inherit;
    position: relative;
    overflow: hidden;
  }
  
  .progress-stripes {
    width: inherit;
    height: inherit;
    font-size: 180px;
    font-weight: bold;
    margin-top: -50px;
    letter-spacing: -14px;
  }
  
  .percentage {
    position: absolute;
    top: 0;
    right: 5px;
    font-weight: bold;
    font-size: 16px;
  }
  /* PURPLE */
  .teal .progress-bar {
    background: #00bcbc;
  }
  .teal .progress-stripes {
    color: #00b4b4;
  }
  .teal .percentage {
    color: #eee;
  }
  .first-step {
    width: 20%;
  }
  .second-step {
    width: 60%;
  }
  .third-step {
    width: 90%;
  }
  .fourth-step {
    width: 100%;
  }
  .fifth-step {
    width: 90%;
  }
  .teal {
    color: #00b4b4;
  }
  .lookup-wrapper {
    text-align: center;
  }
  .lookup-svg {
    width: 300px;
    height: auto;
    max-width: 300px;
    margin-left: auto;
    margin-right: auto;
    margin-right: auto;
    margin: 0 auto;
  }
  .show-all-btn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    border: none;
    /* background: #519bb2; */
    background: rgb(124, 124, 129);
  
    color: #fff;
    border-radius: 4px;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 20px;
  }
  .show-all-btn:hover {
    background: #4d5967;
  }
  .custom-control-label:before {
    background-color: #dedede;
  }
  .custom-checkbox .custom-control-input:checked ~ .custom-control-label::before {
    background-color: #00b4b4 !important;
  }
  input:focus {
    border-color: #00BCBC;
  }
  textarea:focus {
    border-color: #00BCBC;
  }
  .name-link{
    cursor: pointer; 
    color: #00b4b4;
  }
  .name-link:hover{
    text-decoration: underline;
  }
  .overlay-card {
    min-width: 500px;
  }
  </style>
  <style>
  .style-chooser .vs__selected{
        background-color: #00BCBC!important;
        color: #fff!important;
  }
  .style-chooser .vs__dropdown-option--highlight{
      background-color: #00BCBC!important;
      color: #fff!important;
  }
  .style-chooser .vs__selected-options{
    padding: 10px;
  }
  .style-chooser .vs__dropdown-option .vs__dropdown-option--highlight{
    background-color: #00BCBC!important;
    color: #fff!important;
  }
  .style-chooser .vs__deselect{
    fill: #fff;
  }
  .style-chooser .vs__selected{
    border: none;
    font-weight: 300;
    padding: 2px 10px;
  }
  .style-chooser .vs__dropdown-toggle{
    padding: 0;
  }
  .style-chooser .vs__search{
    margin: 0;
    padding: 0;
  }
  
  .form-control {
      display: block;
      width: 100%;
      padding: 0.375rem 0.75rem;
      font-size: 1rem;
      line-height: 1.5;
      color: #495057;
      background-color: #fff;
      background-clip: padding-box;
      border: 1px solid #ced4da;
      border-radius: 0.25rem;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
  textarea {
      overflow: auto;
      resize: vertical;
  }
  button, input, optgroup, select, textarea {
      margin: 0;
      font-family: inherit;
      font-size: inherit;
      line-height: inherit;
  }
  *, ::after, ::before {
      box-sizing: border-box;
  }
  user agent stylesheet
  textarea {
      box-sizing: border-box;
  }
  .success-header{
    background: #00b4b4;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    padding: 50px;
  }
  .success-header img{
      max-width: 200px;
      
  }
  .failure-header{
    background: #5a6877;
    text-align: center;
    color: #fff;
    border-radius: 4px;
    padding: 50px;
  }
  .failure-header img{
      width: 200px;
      
  }
  .success-body{
    text-align: center;
    padding: 50px;
  }
  .failure-body{
    text-align: center;
    padding: 50px;
  }
  .failure-body a{
    color: #00BCBC;
  }
  .failure-body p {
    margin-bottom: 5px;
  }
  .orange{
    color:#f16232
  }
  .header-divide {
  border-top: 1px solid rgba(255, 255, 255, 0.5);
}
.banner-bg {
background-color: #00BCBC;
background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg transform='rotate(0 0 0)' style='transform-origin:center'%3E%3Cg id='c'%3E%3Cg id='b'%3E%3Cuse href='%23a' y='-1400'/%3E%3Cuse href='%23a' y='-1300'/%3E%3Cuse href='%23a' y='-1200'/%3E%3Cuse href='%23a' y='-1100'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-1000'/%3E%3Cuse href='%23a' y='-900'/%3E%3Cuse href='%23a' y='-800'/%3E%3Cuse href='%23a' y='-700'/%3E%3Cuse href='%23a' y='-600'/%3E%3Cuse href='%23a' y='-500'/%3E%3Cuse href='%23a' y='-400'/%3E%3Cuse href='%23a' y='-300'/%3E%3Cuse href='%23a' y='-200'/%3E%3Cuse href='%23a' y='-100'/%3E%3Cg stroke='%2300B4B4' stroke-width='0' id='a'%3E%3Cpath fill='%2300B4B4' d='M0 0l2100 40l-2100 40z'/%3E%3C/g%3E%3Cuse href='%23a' y='100'/%3E%3Cuse href='%23a' y='200'/%3E%3Cuse href='%23a' y='300'/%3E%3Cuse href='%23a' y='400'/%3E%3Cuse href='%23a' y='500'/%3E%3Cuse href='%23a' y='600'/%3E%3Cuse href='%23a' y='700'/%3E%3Cuse href='%23a' y='800'/%3E%3Cuse href='%23a' y='900'/%3E%3Cuse href='%23a' y='1000'/%3E%3Cuse href='%23a' y='1100'/%3E%3Cuse href='%23a' y='1200'/%3E%3Cuse href='%23a' y='1300'/%3E%3Cuse href='%23a' y='1400'/%3E%3Cuse href='%23a' y='1500'/%3E%3Cuse href='%23a' y='1600'/%3E%3Cuse href='%23a' y='1700'/%3E%3Cuse href='%23a' y='1800'/%3E%3Cuse href='%23a' y='1900'/%3E%3Cuse href='%23a' y='2000'/%3E%3Cuse href='%23a' y='2100'/%3E%3Cuse href='%23a' y='2200'/%3E%3Cuse href='%23a' y='2300'/%3E%3Cuse href='%23a' y='2400'/%3E%3Cuse href='%23a' y='2500'/%3E%3Cuse href='%23a' y='2600'/%3E%3Cuse href='%23a' y='2700'/%3E%3Cuse href='%23a' y='2800'/%3E%3C/g%3E%3Cuse href='%23b' x='-1' transform='scale(-1 1)'/%3E%3C/g%3E%3Cuse href='%23c' x='' transform='rotate(90 0 0)' style='transform-origin:center'/%3E%3C/g%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
background-attachment: fixed;
background-size: cover;
}

.myTest .custom-control-input {
  margin-top: 0; /* Remove default offset */
}

/* Ensure label text aligns properly */
.myTest .custom-control-label {
  display: flex;
  align-items: center; /* Center the <small> text vertically within the label */
}

/* Adjust <small> styling if needed */
.myTest .form-text {
  margin-top: 0; /* Preserve original inline style */
  line-height: 1.5; /* Improve text alignment */
}

table td{
  word-break: break-word;
}

.radios {
  color: #fff;
}

/* radios */
.control-group {
  margin-top: 5px;
  display: inline-block;
  vertical-align: top;
  text-align: left;
}
.control {
  display: inline-block;
  position: relative;
  padding-left: 25px;
  margin-bottom: 5px;
  cursor: pointer;
  font-size: 18px;
  margin-right: 10px;
}
.control input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}
.control__indicator {
  position: absolute;
  top: 2px;
  left: 0;
  height: 20px;
  width: 20px;
  background: #e6e6e6;
}
.control--radio .control__indicator {
  border-radius: 50%;
}
.control:hover input ~ .control__indicator,
.control input:focus ~ .control__indicator {
  background: #ccc;
}
.control input:checked ~ .control__indicator {
  background: #4d5967;
}
.control:hover input:not([disabled]):checked ~ .control__indicator,
.control input:checked:focus ~ .control__indicator {
  background: #4d5967;
}
.control input:disabled ~ .control__indicator {
  background: #e6e6e6;
  opacity: 0.6;
  pointer-events: none;
}
.control__indicator:after {
  content: "";
  position: absolute;
  display: none;
}
.control input:checked ~ .control__indicator:after {
  display: block;
}
.control--checkbox .control__indicator:after {
  left: 8px;
  top: 4px;
  width: 3px;
  height: 8px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.control--checkbox input:disabled ~ .control__indicator:after {
  border-color: #7b7b7b;
}
.control--radio .control__indicator:after {
  left: 7px;
  top: 7px;
  height: 6px;
  width: 6px;
  border-radius: 50%;
  background: #fff;
}
.control--radio input:disabled ~ .control__indicator:after {
  background: #7b7b7b;
}
  </style>
  